// Auditoria de UX (M6, B5): como nomes e papéis aparecem na tela. Só a exibição muda; o dado salvo
// fica exatamente como a pessoa digitou.

// Partículas que ficam em minúscula no meio do nome ("Camila da Silva").
const PARTICULAS = new Set(['da', 'das', 'de', 'do', 'dos', 'e', 'di', 'du', 'del', 'van', 'von']);

function capitalizar(palavra: string): string {
  // "maria-clara" → "Maria-Clara"; "d'ávila" → "D'Ávila"
  return palavra.replace(/(^|[-'’])(\p{L})/gu, (_, sep: string, letra: string) => sep + letra.toLocaleUpperCase('pt-BR'));
}

/**
 * "LEONARDO LIMA" → "Leonardo Lima"; "camila da silva" → "Camila da Silva";
 * "julia.rodrigues" → "Julia Rodrigues". Vazio devolve vazio.
 */
export function formatarNome(nome: string | null | undefined): string {
  if (!nome) return '';
  const limpo = nome.replace(/[._]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!limpo) return '';
  return limpo
    .toLocaleLowerCase('pt-BR')
    .split(' ')
    .map((palavra, i) => (i > 0 && PARTICULAS.has(palavra) ? palavra : capitalizar(palavra)))
    .join(' ');
}

/** Primeiro nome já formatado, para a saudação ("Olá, Leonardo"). */
export function primeiroNome(nome: string | null | undefined): string {
  return formatarNome(nome).split(' ')[0] ?? '';
}

/** Nome para exibir; sem nome, a parte do e-mail antes do @ (também formatada). */
export function nomeOuEmail(nome: string | null | undefined, email: string | null | undefined): string {
  return formatarNome(nome) || formatarNome(email?.split('@')[0]) || email || '';
}

/** Glossário em português (B5): papel salvo → nome na tela. */
export function nomeDoPapel(papel: string | null | undefined): string {
  if (papel === 'owner') return 'Proprietário';
  if (papel === 'admin') return 'Administrador';
  if (papel === 'member') return 'Membro';
  return papel ?? '';
}
